import { callPostApiv2, callGetApiv2 } from "./api";

export async function getAuditTrailReportList(data) {
      return callPostApiv2("auditTrail/report", data);
}

export async function getAuditTrailReportDetail(reportId) {
      return callGetApiv2("auditTrail/report/" + reportId);
}